import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => (
  <Helmet>
    {title ? <title>{title}</title> : null}

    {description ? <meta name="description" content={description} /> : null}
    {keywords ? <meta name="keywords" content={keywords} /> : null}

    {/* Open Graph */}
    {title ? <meta property="og:title" content={title} /> : null}
    {description ? <meta property="og:description" content={description} /> : null}
    {image ? <meta property="og:image" content={image} /> : null}
    {url ? <meta property="og:url" content={url} /> : null}

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    {title ? <meta name="twitter:title" content={title} /> : null}
    {description ? <meta name="twitter:description" content={description} /> : null}
    {image ? <meta name="twitter:image" content={image} /> : null}

    {/* Canonical */}
    {url ? <link rel="canonical" href={url} /> : null}
  </Helmet>
);

export default SEO;
